<template>
  <div id="app" class="background-light">


    <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top" v-if="isAuthenticated">
      <div class="container-fluid">
        <!-- Logo y texto "Araucann Soft" -->
        <router-link to="/" class="navbar-brand d-flex align-items-center" @click="navbarOpen = false">
          <div class="logo-container">
            <img src="@/assets/logo.webp" alt="Logo" class="logo-img me-2" />
          </div>


        </router-link>

        <button class="navbar-toggler" type="button" @click="navbarOpen = !navbarOpen"
          :aria-expanded="navbarOpen.toString()" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>


        <!-- Contenedor colapsable del menú -->
        <div class="navbar-collapse" :class="{ collapse: true, show: navbarOpen }" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0 scroll-nav">
            <!-- Inicio -->
            <li class="nav-item">
              <router-link to="/" class="nav-link" @click="navbarOpen = false">
                <font-awesome-icon icon="fas fa-home" class="me-1" />
                Inicio
              </router-link>
            </li>

            <li class="nav-item">
              <router-link to="/cultivos" class="nav-link" @click="navbarOpen = false">
                <font-awesome-icon icon="leaf" class="me-1" />
                Cultivos
              </router-link>
            </li>


            <li class="nav-item">
              <router-link to="/flujo_produccion" class="nav-link" @click="navbarOpen = false">
                <font-awesome-icon :icon="['fas', 'industry']" />
                Producción
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/trazabilidad" class="nav-link" @click="navbarOpen = false">
                <font-awesome-icon :icon="['fas', 'route']" />
                Trazabilidad
              </router-link>
            </li>

            <!-- 
            <li class="nav-item">
              <router-link to="/analisis" class="nav-link" @click="navbarOpen = false">
                <font-awesome-icon :icon="['fas', 'flask']" />
                Análisis
              </router-link>
            </li>
            -->
       



            <!-- Stock dropdown -->
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="stockDropdown" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <font-awesome-icon :icon="['fas', 'boxes-stacked']" class="me-1" />
                Stock
              </a>
              <ul class="dropdown-menu" aria-labelledby="stockDropdown">
                <li>
                  <router-link to="/inventario_proveedores" class="dropdown-item" @click="navbarOpen = false">
                    Inventario
                  </router-link>
                </li>

                <li>
                  <router-link to="/gestionar_producto_envasado" class="dropdown-item" @click="navbarOpen = false">
                    Productos Envasados
                  </router-link>
                </li>
                <li>
                  <router-link to="/geneticas" class="dropdown-item" @click="navbarOpen = false">
                    Geneticas
                  </router-link>
                </li>
              </ul>
            </li>


            <li class="nav-item">
              <router-link to="/exportar" class="nav-link" @click="navbarOpen = false">
                <font-awesome-icon :icon="['fas', 'file-arrow-down']" />
                Exportar
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/cumplimiento" class="nav-link" @click="navbarOpen = false">
                <font-awesome-icon :icon="['fas', 'scale-balanced']" class="me-1" />
                Cumplimiento
              </router-link>
            </li>

            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="gestionDropdown" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                <font-awesome-icon :icon="['fas', 'users']" class="me-1" />
                Gestión
              </a>
              <ul class="dropdown-menu" aria-labelledby="gestionDropdown">
                <li>
                  <router-link to="/personal" class="dropdown-item" @click="navbarOpen = false">
                    Personal
                  </router-link>
                </li>
                <li>
                  <router-link to="/usuarios-medicinales" class="dropdown-item" @click="navbarOpen = false">
                    Usuarios Medicinales
                  </router-link>
                </li>
                <li>
                  <router-link to="/club" class="dropdown-item" @click="navbarOpen = false">
                    Club
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>

          <!-- Botones de notificaciones y configuración -->
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0">


            <li class="nav-item">
              <a class="nav-link nav-icon" @click="irALibretaTareas" title="Tareas pendientes">
                <font-awesome-icon :icon="['fas', 'book']" class="me-1" />
              </a>
            </li>

            <li class="nav-item position-relative">
              <a class="nav-link nav-icon" @click="verNotificaciones" title="Notificaciones">
                <font-awesome-icon icon="fas fa-bell" />
                <span v-if="cantidadAlertas > 0" class="badge bg-danger badge-notificacion">{{ cantidadAlertas }}</span>
              </a>
            </li>

            <li class="nav-item dropdown">
              <a class="nav-link nav-icon dropdown-toggle" href="#" id="configDropdown" data-bs-toggle="dropdown"
                title="Configuración">
                <font-awesome-icon icon="fas fa-cog" />
              </a>
              <ul class="dropdown-menu dropdown-menu-end custom-dropdown-end" aria-labelledby="configDropdown">
                <li><a class="dropdown-item" @click="irAConfiguracion">Configuración</a></li>
                <li><a class="dropdown-item" @click="cerrarSesion">Cerrar sesión</a></li>
              </ul>
            </li>




          </ul>
        </div>
      </div>
    </nav>

    <div class="container-fluid mt-5 pt-5">
      <OnboardingWrapper v-if="isAuthenticated" :is-authenticated="isAuthenticated">
        <router-view />
      </OnboardingWrapper>
      <router-view v-else />
    </div>



    <AlertaModal v-model:mostrar="mostrarModalAlertas" :alertas="alertas" />

  </div>
</template>


<script>
import axios from 'axios'
import AlertaModal from '@/components/Alertas/AlertaModal.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import OnboardingWrapper from '@/components/Onboarding/OnboardingWrapper.vue'

export default {
  components: {
    FontAwesomeIcon,
    AlertaModal,
    OnboardingWrapper
  },
  data() {
    return {
      isAuthenticated: false,
      mostrarModalAlertas: false,
      alertas: {},
      navbarOpen: false // ⬅️ control manual del colapso

    }
  },
  computed: {
    cantidadAlertas() {
      return Object.values(this.alertas).reduce((total, grupo) => total + grupo.length, 0)
    }
  },
  created() {
    this.checkAuthentication()
    this.$router.beforeEach((to, from, next) => {
      this.checkAuthentication()
      next()
    })
    this.obtenerAlertas()
  },
  methods: {
    async obtenerAlertas() {
      try {
        const clubId = JSON.parse(localStorage.getItem('club'))?.id
        if (!clubId) return
        const { data } = await axios.get(`http://localhost:3000/api/alertas?club_id=${clubId}`)

        this.alertas = data
        //ordenar las alertas por mayor cantidad a menor
        this.alertas = Object.fromEntries(
          Object.entries(this.alertas).sort(([, a], [, b]) => b.length - a.length)
        )
      } catch (error) {
        console.error('Error al obtener alertas', error)
      }
    },
    verNotificaciones() {
      this.navbarOpen = false
      this.mostrarModalAlertas = true
    },
    irALibretaTareas() {
      this.navbarOpen = false
      this.$router.push('/libreta-tareas')
    },
    irAConfiguracion() {
      this.navbarOpen = false
      this.$router.push('/configuracion')
    },
    cerrarSesion() {
      if (!confirm('¿Estás seguro de cerrar sesión?')) return
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('club')
      this.$store.commit('limpiarUsuarioActual')
      this.$store.commit('limpiarClubActual')
      this.$store.commit('limpiarProyectoActual')
      this.$store.commit('limpiarEventoActual')
      this.isAuthenticated = false

      // Desactivar temporalmente el interceptor de respuestas
      const interceptor = axios.interceptors.response.use(response => response, error => Promise.reject(error));
      axios.interceptors.response.eject(interceptor);

      this.$router.push({ name: 'BienvenidaPublica' })
    },
    checkAuthentication() {
      const token = localStorage.getItem('token')
      this.isAuthenticated = !!token
      if (this.isAuthenticated) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      } else {
        delete axios.defaults.headers.common['Authorization']

      }
    },


  }
}


</script>



<style scoped>
/* Navbar: se pinta con el primary en lugar del gris */
.navbar {
  background-color: var(--bs-primary) !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  min-height: 0;
  /* elimina la altura mínima */
  line-height: 1;
  /* ajusta el line-height de los hijos */
}


/* Permitir que el dropdown se muestre sobre el navbar scrollable */
.nav-item.dropdown {
  position: relative;
}

.nav-item.dropdown .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1050;
  min-width: max-content;
  white-space: nowrap;
}

/* Fondo general neutro */
.background-light {
  background-color: var(--bs-light);
  min-height: 100vh;
}

/* Responsive: padding reducido en móviles */
@media (max-width: 768px) {
  .navbar {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}

/* Mantener navbar fijo en la parte superior */
.fixed-top {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1030;
}

/* Logo y texto */
.navbar-brand {
  display: flex;
  align-items: center;
}

.text-light-gray {
  /* Texto secundario: gris oscuro */
  color: var(--bs-dark);
}

.logo-container {
  height: 40px;
  width: auto;
  display: flex;
  align-items: center;
}

.logo-img {
  height: 50px;
  /* más grande que el contenedor */
  object-fit: cover;
  object-position: center;
  /* o top/bottom si querés ajustar */
}

/* Forzar scroll horizontal sin ocultar dropdowns */
.navbar-nav.scroll-nav {
  flex-wrap: nowrap !important;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.scroll-nav {
  overflow: visible !important;
}

/* Estilos de los enlaces del menú */
.navbar-dark .navbar-nav .nav-link {
  color: var(--bs-light);
  margin-right: 10px;
  font-size: 0.95rem;
  padding: 5px 10px;
  transition: background-color 0.3s, color 0.3s;
}

/* Hover: fondo secondary y texto claro */
.navbar-dark .navbar-nav .nav-link:hover {
  background-color: var(--bs-secondary);
  color: var(--bs-light);
  border-radius: 5px;
}

/* Botones de notificación y configuración */
.nav-icon {
  position: relative;
  padding: 5px 10px;
}

.nav-icon .badge {
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 0.75rem;
}

/* Hover en outline-light: fondo oscuro y texto claro */
.btn-outline-light:hover {
  background-color: var(--bs-dark);
  color: var(--bs-light);
}

/* Contenedor principal con padding para el navbar fijo */
.container {
  max-width: 1200px;
  padding-top: 70px;
}

.nav-icon {
  position: relative;
  font-size: 1.2rem;
  padding: 8px;
  color: var(--bs-light);
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.3s;
  border-radius: 5px;
}

.nav-icon:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.badge-notificacion {
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 0.65rem;
  padding: 3px 5px;
  border-radius: 10px;
}

.custom-dropdown-end {
  right: 0 !important;
  left: auto !important;
  transform: translateX(0) !important;
  min-width: 200px;
}
</style>
